module.exports = __webpack_public_path__ + "media/images/weather/54_night-bfa5c6efed8cd080c1debcaa5d430581.png";